export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/543e4dfbcbbe62f7e55da5e7b2dbc6a8d2629887/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"